var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.icon)?_c(_setup.icon,{tag:"component",attrs:{"width":"32px","height":"32px"}}):_c('div',[_vm._v("Invalid icon")])
}
var staticRenderFns = []

export { render, staticRenderFns }